import { render } from "./reduction.vue?vue&type=template&id=00eef5f9&scoped=true"
import script from "./reduction.vue?vue&type=script&lang=js"
export * from "./reduction.vue?vue&type=script&lang=js"

import "./reduction.vue?vue&type=style&index=0&id=00eef5f9&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00eef5f9"]])

export default __exports__